import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/lightBulb.svg'
import _imports_1 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-9937f492"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "tw-flex tw-items-center tw-justify-between tw-gap-2.5 tw-px-5 tw-bg-[#F2F8FF] tw-border tw-border-[#E4F1FF] tw-rounded-md tw-min-h-[50px] tw-py-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tw-w-[18px] tw-h-[18px]",
  src: _imports_0,
  alt: "light"
}, null, -1))
const _hoisted_3 = { class: "text tw-text-[#211F58] tw-text-[15px] tw-font-normal tw-w-full" }

import { computed, onMounted, PropType, Ref, ref, watch } from "vue";
import AssessmentQuestionsTable from "@/components/assessment/assessmentQuestionsTable.vue";
import { IAssessmentQuestionTable } from "@/interfaces/assessments/IAssessmentDetails";
import { getComponentUiText } from "@/utils/utilities";
import {
  getDataChecklistGroup,
  getDataChecklistGroupSuggestedActions,
  getDataChecklistGroupAction,
} from "@/services/recommend";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'questions',
  props: {
  action: {
    type: Object as PropType<{
      checklistGroupId: string;
      checklistGroupTemplateId: string;
    }>,
    required: false,
    default: () => ({}),
  },
  isSuggestedAction: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  isCreateAction: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  assessmentQuestionsSelected: {
    type: Array as PropType<IAssessmentQuestionTable[]>,
    required: false,
    default: () => [],
  },
},
  setup(__props) {

const props = __props;



const assessmentQuestions: Ref<IAssessmentQuestionTable[]> = ref(
  props.isCreateAction ? props.assessmentQuestionsSelected : [],
);
const isShowTip: Ref<boolean> = ref(false);
const isLoading: Ref<boolean> = ref(false);
const checklistItemsOfGroup: Ref<
  IAssessmentQuestionTable["checklistItemId"][]
> = ref([]);

const checklistId = computed(
  () => store.getters["Recommend/getChecklistReportId"],
);

const isFetchingChecklistAssessmentQuestion = computed<boolean>(
  () => store.state.Recommend.isFetchingChecklistAssessmentQuestion,
);

const checklistAssessmentQuestion = computed<IAssessmentQuestionTable[]>(() =>
  store.getters["Recommend/getChecklistAssessmentQuestions"](false),
);

onMounted(() => {
  if (props.action.checklistGroupId || props.action.checklistGroupTemplateId) {
    isLoading.value = true;
    getChecklistGroupData();
  }
});

watch(
  () => [checklistItemsOfGroup.value, checklistAssessmentQuestion.value],
  async () => {
    if (
      checklistItemsOfGroup.value.length &&
      checklistAssessmentQuestion.value.length
    ) {
      await getTableData();
    }
  },
);

const getChecklistGroupData = async () => {
  if (
    props.action?.checklistGroupId ||
    props.action?.checklistGroupTemplateId
  ) {
    try {
      const res =
        props.isSuggestedAction || props.action?.checklistGroupTemplateId
          ? await getDataChecklistGroupSuggestedActions(
              checklistId.value,
              props.action?.checklistGroupId ||
                props.action?.checklistGroupTemplateId,
            )
          : await getDataChecklistGroup(
              checklistId.value,
              props.action?.checklistGroupId ||
                props.action?.checklistGroupTemplateId,
            );
      checklistItemsOfGroup.value = res.data?.data?.checklistItems || [];
    } catch (error: any) {
      const message = error?.response?.data?.message || "";
      const emitData: IToastMessage = {
        variant: ToastVariant.ERROR,
        message,
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } else {
    isLoading.value = false;
  }
};
const getTableData = async () => {
  const loop = (
    arrayQuestion: IAssessmentQuestionTable[],
    arrayId: number[],
  ) => {
    const output: IAssessmentQuestionTable[] = [];
    for (let i = 0, n = arrayQuestion.length, m = arrayId.length; i < n; ++i) {
      if (output.length === m) {
        return output;
      }
      const question = arrayQuestion[i];
      if (arrayId.includes(question.checklistItemId)) {
        output.push({ ...question, checklistChildren: undefined });
      }
      if (question.checklistChildren?.length) {
        const data = loop(
          question.checklistChildren as IAssessmentQuestionTable[],
          arrayId,
        );
        output.push(...data);
      }
    }
    return output;
  };
  assessmentQuestions.value = loop(
    checklistAssessmentQuestion.value,
    checklistItemsOfGroup.value,
  );
  isLoading.value = false;
};

const deleteAssessmentQuestion = (id) => {
  assessmentQuestions.value = assessmentQuestions.value.filter((item) => {
    return item.checklistItemId !== id;
  });
  if (id) {
    store.commit("Recommend/SET_CHECKLIST_ASSESSMENT_QUESTIONS", id);
    store.commit("Recommend/REMOVE_SELECTED_ASSESSMENT_QUESTIONS", id);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      __props.action.checklistGroupId ||
      __props.action.checklistGroupTemplateId ||
      __props.isCreateAction
    )
      ? (_openBlock(), _createBlock(AssessmentQuestionsTable, {
          key: 0,
          loading: isFetchingChecklistAssessmentQuestion.value,
          "table-data": assessmentQuestions.value,
          "in-modal-edit": true,
          column: [
      'orderNumber',
      'checklistItemImportanceId',
      'totalScore',
      'action',
    ],
          onDeleteAssessmentQuestion: deleteAssessmentQuestion
        }, null, 8, ["loading", "table-data"]))
      : _createCommentVNode("", true),
    (isShowTip.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
          "app-assess-recommendations-edit-action-modal-action-question-note-1",
        )), 1),
          _createElementVNode("img", {
            class: "svg tw-w-3 tw-h-3 tw-cursor-pointer",
            src: _imports_1,
            alt: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowTip.value = false))
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})